import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { LabelMediumBold, ParagraphMedium, Stack } from '../../../../../../../primitives/index.js';
export const CategoryItem = ({
  title,
  description,
  badge
}) => {
  return _jsxs(Stack, {
    spacing: "xSmall",
    children: [_jsx(LabelMediumBold, {
      children: title
    }), _jsx(ParagraphMedium, {
      children: description
    }), badge]
  });
};